import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="page center">
      <h1>Not found</h1>
      <p className="muted">That page does not exist.</p>
      <Link className="link" to="/app">
        Back to overview
      </Link>
    </main>
  );
}
